import React from 'react';

export default function FactGrid({ items }) {
  return (
    <div className="portal-fact-grid">
      {items.map((item, i) => (
        <div key={i} className="portal-fact">
          <div className="portal-fact-key">{item.k}</div>
          <div className="portal-fact-val">{item.v}</div>
        </div>
      ))}
    </div>
  );
}
